import type { Config } from "dompurify";

/**
 * Link and source addresses the document renderer lets through: DOMPurify's
 * own allowlist plus `blob:`. Fragments (`#page-5`), relative paths
 * (`doc-pages/…`) and protocol-relative URLs pass; `data:` stays allowed on
 * media tags only (DOMPurify's data-URI tags).
 *
 * The pattern used before ended in `\/?[^\s]*`, so any address without
 * whitespace passed — `javascript:` and `vbscript:` included (LAR-487). React
 * 19 blocks a `javascript:` URL it sets itself, but markup injected as HTML
 * (the amendment diff, timeline items) bypasses React, so only the sanitizer
 * stands between such a link and a click.
 */
export const SAFE_URI_PATTERN =
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix|blob):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;

/** DOMPurify config for the markup the document renderer parses or injects. */
export const SANITIZE_HTML_OPTIONS: Config = {
  ALLOW_UNKNOWN_PROTOCOLS: false,
  WHOLE_DOCUMENT: false,
  RETURN_TRUSTED_TYPE: false,
  ALLOWED_URI_REGEXP: SAFE_URI_PATTERN,
  // Allow diff markup tags produced by htmldiff-js for the comparison feature
  ADD_TAGS: ["ins", "del"],
  ADD_ATTR: ["class"],
};
